import { canAssignAltcasePrice, hasAltcasePrice } from '../order-management/orderActionHelpers';

/** Public API exposes UUID as `id` (mapToPublic strips `uuid`). */
export function getPublicId(entity) {
  return entity?.id ?? entity?.uuid;
}

const LINE_TERMINAL = new Set(['SHARES_TRANSFERRED', 'COMPLETED', 'CANCELLED']);

function basketAllowsShareTransfer(basketRow) {
  const status = basketRow?.status;
  if (status === 'PAYMENT_RECEIVED') return true;
  return basketRow?.transfer_before_payment === true && status === 'ORDER_PLACED';
}

/** Basket-level transfer when payment received (or trusted ORDER_PLACED) and every open line has Altcase price staged. */
export function canTransferBasketOrder(basketRow, items = basketRow?.items ?? []) {
  if (!basketAllowsShareTransfer(basketRow) || !items.length) return false;

  const basketTrusted = basketRow?.transfer_before_payment === true;
  let hasPendingLine = false;

  for (const line of items) {
    if (LINE_TERMINAL.has(line.status)) continue;
    const lineTrusted = line.transfer_before_payment ?? basketTrusted;
    if (!canAssignAltcasePrice(line.status, lineTrusted)) return false;
    if (!hasAltcasePrice(line)) return false;
    hasPendingLine = true;
  }

  return hasPendingLine;
}

export function enrichBasketLineItems(items, basketRow) {
  const basketTrusted = basketRow?.transfer_before_payment === true;
  return (items ?? []).map((line) => ({
    ...line,
    transfer_before_payment: line.transfer_before_payment ?? basketTrusted,
  }));
}
